const styles = (theme) => ({
  textInput: {
    width: '250px',
    [theme.breakpoints.up('sm')]: {
      width: '350px',
    },
  },
  checkboxInput: {
    width: '250px',
    alignItems: 'flex-start',
    marginLeft: -theme.spacing.unit * 1.5,
    '&:first-of-type': {
      border: 'none',
    },
    '& > span:first-child': {
      marginTop: -theme.spacing.unit * 1.5,
    },
    [theme.breakpoints.up('sm')]: {
      width: '350px',
    },
  },
  dayInput: {
    width: 40,
  },
  monthInputContainer: {
    margin: '0 10px',
  },
  monthInput: {
    width: 40,
  },
  yearInput: {
    width: 80,
  },
  dateOfBirthFieldContainer: {
    display: 'flex',
    width: '100%',
  },
  label: {
    fontWeight: 600,
    marginBottom: '8px',
  },
  formField: {
    textAlign: 'left',
  },
  validation: {
    marginTop: theme.spacing.unit * 0.75,
    textAlign: 'left',
    color: theme.palette.error.main,
    fontSize: '1rem',
    lineHeight: '1rem',
    width: '250px',
    [theme.breakpoints.up('sm')]: {
      width: '350px',
    },
    '&:empty': {
      display: 'none',
    },
  },
  title: {
    paddingTop: 0,
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '10px 0',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  },
  avatar: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    borderRadius: '100px',
    color: theme.palette.primary.dark,
    boxSizing: 'content-box',
    padding: '15px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      marginRight: '20px',
    },
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default styles;
